import { Section } from '../../../admin/shared/public-api';

export class ArticleSection<T> extends Section<T> {
  customClass: string;
}
